export const DEFAULT_IGNORE_ERRORS = [
    // ignore common network errors
    /AbortError/,
    /NetworkError/,
    /Failed to fetch/,
    /Resource blocked/,
    // ignore some ad errors
    /webkit.messageHandlers/,
    // ignore origin errors
    /file:\/\//,
    /webcache/,
    /translate/,
    /www\.youtube\.com/,
    /plugin\.ucads\.ucweb\.com/
];
